import { ulid } from "ulid";
import math from "../Mathjs/CustomMathjsInstance";
import { validationError } from "./NewTemplateSignals";

export const validateForm = ({ templateFormData }) => {
  const { templateName, company, branch, department, area } = templateFormData;

  if (!isMainFormValid({ templateName, company, branch, area, department })) {
    validationError.value = "All fields are required";
    return false;
  }

  if (!templateFormData.sections.length) {
    validationError.value = "At least one section is required";
    return false;
  }

  let stageStepFilled = true;

  if (templateFormData.properties?.StageSteps?.length > 0) {
    templateFormData.sections.forEach((section) => {
      if (!section.properties.StageStep) {
        validationError.value = `${section.sectionName} properties must have a selected Template Stage`;
        stageStepFilled = false;
      }
    });
    if (!stageStepFilled) return false;
  }

  if (!areSectionsUnique(templateFormData.sections)) {
    return false;
  }

  if (!areFieldsUnique(templateFormData.sections)) {
    return false;
  }

  for (const section of templateFormData.sections) {
    if (!validateSection(section)) {
      return false;
    }
  }

  removeNewFieldProperty(templateFormData.sections);

  checkSectionIds(templateFormData.sections);

  checkFieldIds(templateFormData.sections);

  return true;
};

function checkSectionIds(sections) {
  sections.forEach((section) => {
    if (section.sectionId === null) {
      section.sectionId = ulid();
    }
  });
}

function checkFieldIds(sections) {
  sections.forEach((section) => {
    section.fields.forEach((field) => {
      if (field.fieldId === null) {
        field.fieldId = ulid();
      }
    });
  });
}

function removeNewFieldProperty(sections) {
  sections.forEach((section) => {
    section.fields.forEach((field) => {
      if (field?.properties?.newField) {
        delete field.properties.newField;
      }
    });
  });
}

function areSectionsUnique(sections) {
  const allSections = [];
  for (const section of sections) {
    if (allSections.includes(section.sectionName)) {
      validationError.value = `Section names must be unique (${section.sectionName})`;
      return false;
    }
    allSections.push(section.sectionName);
  }
  return true;
}

const isMainFormValid = (mainFormFields) => {
  return Object.values(mainFormFields).every((field) => field);
};

const areFieldsUnique = (sections) => {
  const allFields = [];

  for (const section of sections) {
    for (const field of section.fields) {
      const fieldName = field.fieldName?.replace(/\s/g, "");

      if (
        allFields.some((existingField) => existingField.toLowerCase() === fieldName?.toLowerCase())
      ) {
        validationError.value = `Field names must be unique (${field.fieldName})`;
        return false;
      }
      allFields.push(fieldName);
    }
  }
  return true;
};

export const validateSection = (section) => {
  const areFieldsValid = allFieldsAreValid(section.fields, validateField);

  if (!section.sectionName) {
    validationError.value = "Section name is required";
    return false;
  }

  if (section.fields.length === 0) {
    validationError.value = "At least one field is required";
    return false;
  }

  return areFieldsValid;
};

const allFieldsAreValid = (fields, validatorFn) => {
  for (const field of fields) {
    if (!validatorFn(field)) {
      return false;
    }
  }
  return true;
};

export const validateField = (field) => {
  if (!field.fieldName) {
    validationError.value = "Field name is required";
    return false;
  }

  if (!field.fieldType) {
    validationError.value = "Field type is required";
    return false;
  }

  const firstChar = field.fieldName?.charAt(0);

  if (/[0-9!@#$%^&*()_+\-=\]{};':"\\|,.<>?]/.test(firstChar)) {
    validationError.value = "Field names must begin with a letter";
    return false;
  }

  if (Object.hasOwn(math, field.fieldName)) {
    validationError.value = `Field name conflicts with an existing math function (${field.fieldName})`;
    return false;
  }

  return true;
};

export const validateSubSectionFields = (subSectionField) => {
  const properties = subSectionField.properties ? subSectionField.properties : {};
  const selectionMode = properties["SelectionMode"] ? properties["SelectionMode"] : null;
  if (!subSectionField.subSectionFieldName) {
    validationError.value = "SubSection Field name is required";
    return false;
  }
  if (!subSectionField.subSectionFieldType) {
    validationError.value = "SubSection Field type is required";
    return false;
  }
  if (subSectionField.subSectionFieldType === "PeoplePicker" && !selectionMode) {
    validationError.value = "SelectionMode is required for PeoplePicker type";
    return false;
  }
  if (subSectionField.subSectionFieldType === "GroupPicker" && !selectionMode) {
    validationError.value = "SelectionMode is required for GroupPicker type";
    return false;
  }

  return true;
};
